<script setup>
import { computed } from 'vue'

import { useAuditText } from './audit-text.js'
import { asArray } from './run-observer.js'

const props = defineProps({
  person: { type: Object, required: true },
  // characterRecord() 的结果。
  record: { type: Object, required: true },
})

const { tr } = useAuditText()
const cues = computed(() => asArray(props.person.performance_cues))
// 作者可以把口吻示例写成纯字符串，也可以写成带情境的对象（引擎 content.js 同样两种都收）。
const examples = computed(() => asArray(props.person.style_examples).map((example, index) => (typeof example === 'string'
  ? { key: index, situation: '', response: example }
  : { key: index, situation: example.situation || '', response: example.response || '—' })))
</script>

<template>
  <div class="au-fold__body">
    <section class="au-group">
      <h4>{{ tr('characters.facts') }} · {{ record.initial_facts.length }}</h4>
      <ul v-if="record.initial_facts.length" class="au-lines">
        <li v-for="fact in record.initial_facts" :key="fact.id" :title="fact.id">{{ fact.text }}</li>
      </ul>
      <p v-else class="au-empty">{{ tr('empty') }}</p>
    </section>
    <section class="au-group">
      <h4>{{ tr('characters.relations') }} · {{ record.initial_relations.length }}</h4>
      <ul v-if="record.initial_relations.length" class="au-lines">
        <li v-for="relation in record.initial_relations" :key="`${relation.from_id}-${relation.to_id}`">
          <strong>{{ relation.label }}</strong> {{ relation.text }}
        </li>
      </ul>
      <p v-else class="au-empty">{{ tr('empty') }}</p>
    </section>
    <section class="au-group">
      <h4>{{ tr('characters.portrayal') }}</h4>
      <dl class="au-kv">
        <dt>{{ tr('characters.personality') }}</dt>
        <dd>{{ person.profile?.personality || '—' }}</dd>
        <dt>{{ tr('characters.speechStyle') }}</dt>
        <dd>{{ person.profile?.speech_style || '—' }}</dd>
      </dl>
      <template v-if="cues.length">
        <h5>{{ tr('characters.cues') }}</h5>
        <ul class="au-lines">
          <li v-for="(cue, index) in cues" :key="index">{{ cue.text }}</li>
        </ul>
      </template>
      <template v-if="examples.length">
        <h5>{{ tr('characters.examples') }}</h5>
        <ul class="au-lines">
          <li v-for="example in examples" :key="example.key">
            <span v-if="example.situation" class="au-muted">{{ example.situation }} · </span>{{ example.response }}
          </li>
        </ul>
      </template>
    </section>
  </div>
</template>
